import { render } from "./MatriculeVoitureModal.vue?vue&type=template&id=2da0870b&scoped=true"
import script from "./MatriculeVoitureModal.vue?vue&type=script&lang=js"
export * from "./MatriculeVoitureModal.vue?vue&type=script&lang=js"

import "./MatriculeVoitureModal.vue?vue&type=style&index=0&id=2da0870b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da0870b"]])

export default __exports__